import {
  TERMINAL_GEOFENCING_FETCH_REQUEST,
  TERMINAL_GEOFENCING_FETCH_REQUEST_SUCCESS,
  TERMINAL_GEOFENCING_FETCH_REQUEST_FAILURE,
  TERMINAL_GEOFENCING_UPDATE_REQUEST,
  TERMINAL_GEOFENCING_UPDATE_REQUEST_SUCCESS,
  TERMINAL_GEOFENCING_UPDATE_REQUEST_FAILURE,
  TERMINAL_GEOFENCING_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalGeoFencingsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_GEOFENCING_FETCH_REQUEST:
    case TERMINAL_GEOFENCING_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_GEOFENCING_FETCH_REQUEST_SUCCESS:
    case TERMINAL_GEOFENCING_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TERMINAL_GEOFENCING_FETCH_REQUEST_FAILURE:
    case TERMINAL_GEOFENCING_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_GEOFENCING_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default terminalGeoFencingsReducer;
